// Auth0 error.message values recognised by the login error screen.
export const USER_ERROR_SCENARIOS = {
  ACCESS_DENIED: 'Access denied.',
  CONSENT_ERROR: 'Unable to correlate completed consent.',
  BLOCKED_ERROR: 'user is blocked',
  INVALID_STATE: 'Invalid state',
};

export enum LoginErrorType {
  EmailUnverified = 'emailUnverified',
  AccountInactive = 'accountInactive',
  AccountNotConfigured = 'accountNotConfigured',
  ServiceUnavailable = 'serviceUnavailable',
  SignInFailed = 'signInFailed',
}

export interface LoginErrorContent {
  title: string;
  message?: string;
  guidance: string;
  canRetry: boolean;
}

export const LOGIN_ERROR_CONTENT: Record<LoginErrorType, LoginErrorContent> = {
  [LoginErrorType.EmailUnverified]: {
    title: 'Verify your email address',
    message: 'Check your inbox for a verification link.',
    guidance: "Can't find it? Check your spam folder, or contact your system administrator.",
    canRetry: true,
  },
  [LoginErrorType.AccountInactive]: {
    title: 'Account inactive',
    message: 'Your account has been deactivated.',
    guidance: 'Contact your Amtek representative for assistance.',
    canRetry: false,
  },
  [LoginErrorType.AccountNotConfigured]: {
    title: 'Account not set up',
    message: "Your account isn't configured to access CMS2.",
    guidance: 'Contact your system administrator to arrange access.',
    canRetry: false,
  },
  [LoginErrorType.ServiceUnavailable]: {
    title: "We couldn't load your account",
    guidance: 'Try again in a moment. If the problem continues, contact your system administrator.',
    canRetry: true,
  },
  [LoginErrorType.SignInFailed]: {
    title: 'Something went wrong',
    message: "We couldn't complete your sign-in.",
    guidance: 'Try again, and contact your system administrator if it keeps happening.',
    canRetry: true,
  },
};
